<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <!-- <div class="hidden md:col-span-1 md:block" /> -->
            <div class="col-span-12 text-left md:col-span-12">
                <!-- <h2 class="mb-5">Seznam souborných hesel</h2> -->
                <ul class="col-span-12 mb-25 w-full px-0 pt-0">
                    <li
                        v-for="(item, index) in responseData"
                        :key="index"
                        class="mb-0 cursor-pointer border-b p-2 hover:bg-[#FDF0F0]"
                        @click="selectSouborneHeslo(item)"
                    >
                        {{ item["nazev-souborneho-hesla"] }}
                    </li>
                </ul>
            </div>
            <!-- <div class="hidden md:col-span-1 md:block" /> -->
        </div>

        <!-- <AppFooter /> -->
    </div>
</template>

<script setup lang="ts">
const { serverUri } = useDataLogic()

//const store = useMainStore()

const responseData = ref<any>({})

//onMounted
onMounted(async () => {
    CreateSouborneHesloSeznam()
})

async function CreateSouborneHesloSeznam() {
    const data = await $fetch<any[]>("select-souborne-heslo-all", {
        baseURL: serverUri(),
    })
    responseData.value = data
}

const router = useRouter()

function selectSouborneHeslo(item: any) {
    router.push({ name: "souborne-heslo", query: { id: item._id } })
    //results.value = []
}
</script>

<style scoped></style>
